import { render, staticRenderFns } from "./LentiSole.vue?vue&type=template&id=540d73bf&scoped=true"
import script from "./LentiSole.vue?vue&type=script&lang=ts"
export * from "./LentiSole.vue?vue&type=script&lang=ts"
import style0 from "./LentiSole.vue?vue&type=style&index=0&id=540d73bf&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d73bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540d73bf')) {
      api.createRecord('540d73bf', component.options)
    } else {
      api.reload('540d73bf', component.options)
    }
    module.hot.accept("./LentiSole.vue?vue&type=template&id=540d73bf&scoped=true", function () {
      api.rerender('540d73bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LentiSole.vue"
export default component.exports